<script>
  import { router } from '@inertiajs/svelte'

  let { comment = {}, post = {}, versions = [], flash = {} } = $props()

  let blindReason = $state('임시조치 (정보통신망법 제44조의2)')
  let blindDuration = $state(30)
  let showBlindForm = $state(false)

  function approveComment() {
    if (confirm('이 댓글을 승인하시겠습니까?')) {
      router.post(`/admin/comments/${comment.id}/approve`)
    }
  }

  function rejectComment() {
    if (confirm('이 댓글을 삭제하시겠습니까?')) {
      router.post(`/admin/comments/${comment.id}/reject`)
    }
  }

  function blindComment() {
    if (confirm(`이 댓글을 ${blindDuration}일간 블라인드 처리하시겠습니까?`)) {
      router.post(`/admin/comments/${comment.id}/blind`, {
        reason: blindReason,
        duration_days: blindDuration
      })
      showBlindForm = false
    }
  }

  function unblindComment() {
    if (confirm('이 댓글의 블라인드를 해제하시겠습니까?')) {
      router.post(`/admin/comments/${comment.id}/unblind`)
    }
  }

  function getStatusBadge(status) {
    switch (status) {
      case 'approved': return 'badge-success'
      case 'pending': return 'badge-info'
      case 'flagged': return 'badge-warning'
      case 'rejected': return 'badge-error'
      default: return 'badge-neutral'
    }
  }
</script>

<!-- Breadcrumb -->
  <div class="flex items-center gap-2 text-caption text-content-tertiary mb-6">
    <a href="/admin" class="hover:text-primary transition-colors">관리자</a>
    <span>/</span>
    <a href="/admin/comments" class="hover:text-primary transition-colors">댓글</a>
    <span>/</span>
    <span class="text-content">댓글 상세</span>
  </div>

  <main class="max-w-4xl">
    {#if flash?.notice}
      <div class="mb-6 p-4 bg-success-light dark:bg-success/20 border border-success/30 rounded-xl text-success-dark dark:text-success text-body2">
        {flash.notice}
      </div>
    {/if}
    {#if flash?.alert}
      <div class="mb-6 p-4 bg-error-light dark:bg-error/20 border border-error/30 rounded-xl text-error-dark dark:text-error text-body2">
        {flash.alert}
      </div>
    {/if}

    <!-- Blind Status Banner -->
    {#if comment.is_blinded}
      <div class="mb-6 p-4 bg-error-light dark:bg-error/20 border border-error/30 rounded-xl">
        <div class="flex items-center justify-between">
          <div>
            <div class="text-error-dark dark:text-error font-semibold text-body1 mb-1">블라인드 처리됨</div>
            <div class="text-body2 text-error-dark/80 dark:text-error/80">
              사유: {comment.blind_reason || '-'}
            </div>
            {#if comment.blind_expires_at}
              <div class="text-caption text-error-dark/60 dark:text-error/60 mt-1">
                만료: {new Date(comment.blind_expires_at).toLocaleString('ko-KR')}
              </div>
            {/if}
          </div>
          <button onclick={unblindComment} class="btn btn-secondary btn-sm">블라인드 해제</button>
        </div>
      </div>
    {/if}

    <!-- Comment Info -->
    <div class="card card-bordered overflow-hidden mb-6 shadow-md">
      <div class="p-6 border-b border-default">
        <div class="flex items-start justify-between">
          <div class="flex items-center gap-2">
            <span class={`badge ${getStatusBadge(comment.moderation_status)}`}>
              {comment.moderation_status || 'approved'}
            </span>
            {#if comment.is_blinded}
              <span class="badge badge-error">블라인드</span>
            {/if}
            <span class="text-caption text-content-tertiary">댓글 ID: {comment.id?.substring(0, 8)}...</span>
          </div>

          <div class="flex items-center gap-2">
            {#if comment.moderation_status !== 'approved'}
              <button onclick={approveComment} class="btn btn-primary btn-sm">승인</button>
            {/if}
            {#if !comment.is_blinded}
              <button onclick={() => showBlindForm = !showBlindForm} class="btn btn-warning btn-sm">블라인드</button>
            {/if}
            <button onclick={rejectComment} class="btn btn-danger btn-sm">삭제</button>
          </div>
        </div>
      </div>

      <!-- Blind Form -->
      {#if showBlindForm}
        <div class="p-6 border-b border-default bg-warning-light/50 dark:bg-warning/10">
          <h3 class="text-label font-semibold text-content mb-3">블라인드 처리</h3>
          <div class="flex flex-col gap-3">
            <div>
              <label for="blind-reason" class="text-caption text-content-tertiary mb-1 block">사유</label>
              <input id="blind-reason" type="text" bind:value={blindReason} class="input w-full py-2" />
            </div>
            <div>
              <label for="blind-duration" class="text-caption text-content-tertiary mb-1 block">기간 (일)</label>
              <select id="blind-duration" bind:value={blindDuration} class="select">
                <option value={7}>7일</option>
                <option value={14}>14일</option>
                <option value={30}>30일</option>
                <option value={60}>60일</option>
                <option value={90}>90일</option>
              </select>
            </div>
            <div class="flex items-center gap-2">
              <button onclick={blindComment} class="btn btn-warning btn-sm">블라인드 적용</button>
              <button onclick={() => showBlindForm = false} class="btn btn-secondary btn-sm">취소</button>
            </div>
          </div>
        </div>
      {/if}

      <!-- Author -->
      <div class="p-6 border-b border-default bg-surface-tertiary">
        <div class="flex items-center justify-between">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 bg-primary-50 dark:bg-dark-elevated rounded-full flex items-center justify-center text-primary dark:text-dark-text-high font-semibold">
              {comment.user?.name?.charAt(0) || '?'}
            </div>
            <div>
              <div class="text-body1 font-medium text-content">{comment.user?.name || '익명'}</div>
              <div class="text-caption text-content-tertiary">{comment.user?.email || ''}</div>
            </div>
          </div>
          <div class="text-caption text-content-tertiary">
            {new Date(comment.created_at).toLocaleString('ko-KR')}
          </div>
        </div>
      </div>

      <!-- Content -->
      <div class="p-6">
        <div class="text-body2 text-content whitespace-pre-wrap">
          {comment.content}
        </div>
      </div>

      <!-- Stats -->
      <div class="p-6 border-t border-default bg-surface-tertiary">
        <div class="flex items-center gap-6 text-body2">
          <span class="text-content-secondary">추천 <span class="font-semibold text-content">{comment.likes_count || 0}</span></span>
          <span class="text-content-secondary">공개범위 <span class="font-semibold text-content">{comment.privacy_level || '-'}</span></span>
          {#if comment.parent_id}
            <span class="badge badge-neutral">대댓글</span>
          {/if}
        </div>
      </div>

      <!-- AI Moderation -->
      {#if comment.ai_moderation_result}
        <div class="p-6 border-t border-default">
          <h3 class="text-label text-content-tertiary uppercase mb-3">AI 모더레이션 결과</h3>
          <pre class="bg-surface-tertiary p-4 rounded-xl text-body2 text-gray-700 dark:text-dark-text-medium overflow-x-auto border border-default">{JSON.stringify(comment.ai_moderation_result, null, 2)}</pre>
        </div>
      {/if}
    </div>

    <!-- Parent Post -->
    {#if post}
      <div class="card card-bordered overflow-hidden mb-6 shadow-md">
        <div class="px-6 py-4 border-b border-default">
          <h2 class="text-title text-content">원글</h2>
        </div>
        <a href={`/admin/posts/${post.id}`} class="block p-6 hover:bg-gray-50 dark:hover:bg-dark-tertiary transition-colors">
          <h3 class="text-body1 font-semibold text-content mb-1">{post.title}</h3>
          <div class="text-caption text-content-tertiary">
            {post.user?.name || '익명'} · {post.board?.name || '-'}
          </div>
        </a>
      </div>
    {/if}

    <!-- Version History -->
    {#if versions.length > 0}
      <div class="card card-bordered overflow-hidden mb-6 shadow-md">
        <div class="px-6 py-4 border-b border-default">
          <h2 class="text-title text-content">수정 이력</h2>
        </div>
        <div class="divide-y divide-gray-100 dark:divide-dark-border">
          {#each versions as version}
            <div class="px-6 py-4">
              <div class="flex items-center justify-between mb-2">
                <span class="text-content font-medium">{version.event}</span>
                <span class="text-caption text-content-tertiary">{new Date(version.created_at).toLocaleString('ko-KR')}</span>
              </div>
            </div>
          {/each}
        </div>
      </div>
    {/if}

    <!-- Back -->
    <div class="flex justify-center mt-8">
      <a href="/admin/comments" class="btn btn-secondary btn-md">목록으로</a>
    </div>
  </main>
